module.exports = __webpack_public_path__ + "files/6fdfae1817c9e80ece33691c08755f1c.svg";